import { useSuspenseQuery } from '@apollo/client';

import { CompaniesSegmentsDocument } from '../../graphql/queries/companies-segments.gql-types';

type useCompaniesSegmentsProps = {
  industryId?: string;
  skip: boolean;
};
export const useCompaniesSegments = ({
  industryId = '',
  skip = false,
}: useCompaniesSegmentsProps) => {
  const response = useSuspenseQuery(CompaniesSegmentsDocument, {
    variables: {
      industryId,
    },
    skip,
  });

  return response;
};
